export enum FeedbackAccessMode {
  REVIEWER = 'REVIEWER',
  REVIEWEE = 'REVIEWEE',
}

export function parseFeedbackAccessMode(value: string | null): FeedbackAccessMode {
  return value === FeedbackAccessMode.REVIEWEE
    ? FeedbackAccessMode.REVIEWEE
    : FeedbackAccessMode.REVIEWER;
}

export enum FeedbackAccessSource {
  ORGANIZATION = 'ORGANIZATION',
  MENTOR = 'MENTOR',
  POSITION = 'POSITION',
  SHARED = 'SHARED',
}

export interface IFeedbackAccessSummary {
  employeeId: number;
  fullName: string;
  positionTitle: string;
  photo: string | null;
  organizationCount: number;
  positionCount: number;
  sharedCount?: number;
}

export interface IFeedbackAccessDetailEntry {
  employeeId: number;
  fullName: string;
  positionTitle: string;
  photo: string | null;
  source: FeedbackAccessSource;
  accessId?: number;
  grantedByName?: string;
  grantedAt?: string;
}

export interface ShareableEmployeeResponse {
  employeeId: number;
  fullName: string;
  positionTitle: string;
  photo: string | null;
}

export interface IFeedbackVisibilityRow {
  employeeId: number;
  name: string;
  position: string;
  photo: string | null;
  organization: number;
  positionAccess: number;
  shared: number;
  canSee: number;
  seenBy: number;
}

export interface ISharedPacketAccess {
  accessId: number;
  fullName: string;
  positionTitle: string;
  grantedAt: string;
}

export interface ShareFeedbackRequest {
  revieweeId: number;
  viewerIds: number[];
}
